export { default as Root } from './Root';
export { default as Comparison } from './Comparison';
export { default as ComparisonHighlight } from './ComparisonHighlight';
export { default as ComparisonSearch } from './ComparisonSearch';
export { default as Apply } from './Apply';
export { default as ApplyTarget } from './ApplyTarget';
export { default as Upload } from './Upload';
export { default as Login } from './Login';
export { default as Uploader } from './Uploader';
export { default as Search } from './Search';
export { default as RouteList } from './RouteList';
export { default as SnackbarsMessage } from './SnackbarsMessage';
export { default as UploadForRiskJudge } from './UploadForRiskJudge';
export { default as RiskJudge } from './RiskJudge';
export { default as UploadForHighlight } from './UploadForHighlight';
export { default as UploadForSearch } from './UploadForSearch';



// WEBPACK FOOTER //
// ./src/components/index.tsx